import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Datefilter(state = initialState, action) {
  switch (action.type) {
    case userConstants.DATEFILTER_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.DATEFILTER_SUCCESS:
      const {res} = action
      return {
        res,
        isLoading : false
      };
    case userConstants.DATEFILTER_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}